import type { AbsenceSyncSchedule } from './model';

export const defaultAbsenceSyncSchedule: AbsenceSyncSchedule = {
  version: 0, useCompanyDefault: true, workdayStart: '09:30', workdayEnd: '19:00', timeZone: 'Asia/Seoul', halfDayBoundary: '14:30',
};

export function absenceSyncScheduleError(schedule: AbsenceSyncSchedule): string | undefined {
  if (schedule.useCompanyDefault) return undefined;
  const clock = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
  if (!clock.test(schedule.workdayStart) || !clock.test(schedule.workdayEnd)) return '근무 시작과 종료 시간을 모두 입력해 주세요.';
  if (schedule.workdayStart >= '11:30' || schedule.workdayEnd <= '16:30') return '반차·반반차 연동을 위해 근무 시작은 11:30 이전, 종료는 16:30 이후로 입력해 주세요.';
  return undefined;
}
